import {
  websiteBuilderGenerateDividerDesignStyles,
  IWebsiteBuilderDivider,
} from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderDivider";
import React from "react";

interface IWebsiteBuilderDividerViewProps {
  node: IWebsiteBuilderDivider;
}

export function WebsiteBuilderDividerView(props: IWebsiteBuilderDividerViewProps) {
  const { node } = props;

  const settings = node.element.settings;
  const designStyles = websiteBuilderGenerateDividerDesignStyles(settings);

  return (
    <hr
      className={designStyles.className}
      style={designStyles.styleProperties}
    />
  );
}
